import React from "react";

import PageStructure from "../components/ui/PageStructure";
import { IN_PROGRESS_GOAL } from "../utils/constants";

// component for in progress goals page
const InProgress: React.FC = () => {
  return <PageStructure title="in progress goals" filter={IN_PROGRESS_GOAL} />;
};

export default InProgress;
